export default __webpack_public_path__ + "static/media/payment-blank-amex.360430f3.svg";